export default __webpack_public_path__ + "static/media/banner.2bce3a37.jpg";